module.exports = __webpack_public_path__ + "img/style_model_preview_669.2bc4ef41.jpg";